export default {"src":"/_next/static/media/phone-black.da2dbbdc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};